/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_List_Subtitle1Inputs */

const vi_cmspost_list_subtitle1 = /** @type {(inputs: Cmspost_List_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tin tức, cẩm nang trà trên website (/tin-tuc). Bài mới là nháp; bấm Đăng mới lên web.`)
};

/**

* @param {Cmspost_List_Subtitle1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_list_subtitle1 = /** @type {((inputs?: Cmspost_List_Subtitle1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_List_Subtitle1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_list_subtitle1(inputs)
});
export { cmspost_list_subtitle1 as "cmsPost_list_subtitle" }